import {range, xor} from 'lodash'
import React, {useCallback, useState} from 'react'
import {isAuthMode} from 'src/shared/config'

import {useIsMobile} from '../../hooks'
import CommentButton from './CommentButton'
import {CommentDesktop} from './desktop'
import {useSendFeedback} from './Feedback.hooks'
import FeedbackDetails from './FeedbackDetails'
import {CommentMobile, CommentMobileAuth} from './mobile'
import Star from './Star'
import {useStyles} from './styles'

const MAX_SCORE = 5

const Feedback: React.FC = () => {
  const classes = useStyles()
  const [feedback, sendFeedback] = useSendFeedback()
  const isMobile = useIsMobile()
  const CommentModalComponent = isMobile ? (isAuthMode ? CommentMobileAuth : CommentMobile) : CommentDesktop
  const {reasonIDs, score, comment} = feedback

  const getSetScoreHandler = (newScore: number) => () => {
    // если прошлая либо новая оценка 5, нужно сбросить все выбранные до этого теги
    // чтобы не отправлять лишнего
    const newReasonIDs = [newScore, score].some(value => value === 5) ? [] : reasonIDs
    sendFeedback({score: newScore, reasonIDs: newReasonIDs})
  }

  const setReasons = useCallback(
    (newReasonID: string) => {
      sendFeedback({reasonIDs: xor(reasonIDs || [], [newReasonID])})
    },
    [sendFeedback, reasonIDs],
  )
  const [showCommentModal, setShowCommentModal] = useState(false)

  const setShown = useCallback(() => setShowCommentModal(true), [])
  const setHidden = useCallback(() => setShowCommentModal(false), [])

  const handleCommentModalSubmit = useCallback(
    (newComment?: string) => {
      sendFeedback({comment: newComment})
      setHidden()
    },
    [sendFeedback, setHidden],
  )

  return (
    <div className={classes.wrapper}>
      <div className={classes.border}>
        <div className={classes.score}>
          {range(1, MAX_SCORE + 1).map(n => (
            <Star
              data-e2e={`feedback-star-${n}`}
              key={n}
              onClick={getSetScoreHandler(n)}
              selected={score !== undefined && n <= score}
            />
          ))}
        </div>
        {score && <FeedbackDetails onChange={setReasons} score={score} selected={reasonIDs} />}
        {score && <CommentButton feedback={comment} onClick={setShown} />}
        {showCommentModal && (
          <CommentModalComponent comment={comment} onClose={setHidden} onSubmit={handleCommentModalSubmit} />
        )}
      </div>
    </div>
  )
}

export default Feedback
